import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  planCardFrame: {
    width: '100%',
    background: '#fff',
    padding: '16px',
  },
  planCardSelectedFrame: {
    width: '400px',
    height: '62px',
    background: '#F7F7F7',
    padding: '16px',
  },
  planCardTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '15px',
    overflow: 'hidden',
    color: '#000000',
    display: '-webkit-box',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
  planCardSubTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '12px',
    marginTop: '4px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
}));

const PlanCard = (props) => {
  const classes = useStyles();

  return (
    <div>
      <Grid container direction="column" className={classes.planCardFrame}>
        <Grid item className={classes.planCardTitle}>
          {props.textVal}
        </Grid>
        <Grid item className={classes.planCardSubTitle}>
          {props.subTextVal}
        </Grid>
      </Grid>
    </div>
  );
};

export default PlanCard;
